<template>
    <div class="datePicker">
        <vue2-datepicker value-type="format" v-model="date"></vue2-datepicker>
        <input type="hidden" :name="name" :value="date" />
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: {
        'vue2-datepicker': DatePicker
    },
    props: {
        name: {},
        initialValue: {},
    },
    data() {
        return {
            date: ''
        }
    },
    mounted() {
        this.date = this.initialValue;
    },
    methods: {
        
    }
}
</script>